<template>
  <section>
    <div style="display: flex" class="mt-6 mb-2">
      <h4 class="title is-4">Events</h4>
      <transition name="fade">
        <download-csv v-if="exportData && exportData.length > 0" class="ml-auto"
                      :data="exportData"
                      :name="exportFileName">
          <b-button type="is-success" icon-left="download">
            Export CSV
          </b-button>
        </download-csv>
      </transition>

      <transition name="fade">
        <download-file ref="downloadVideos" @onDownloadClicked="onDownloadVideosClicked" class="ml-2" v-if="checkedRows.length > 0">Download snippets
        </download-file>
      </transition>

    </div>
    <div class="box p-4 mb-6">
      <b-table
          key="single_incident_table"
          ref="table"
          :data="incidentTableData"
          :checked-rows.sync="checkedRows"
          checkable
          checkbox-position="left"
          checkbox-type="is-primary"
          hoverable
          paginated
          per-page="5"
          :current-page.sync="currentPage"
          :pagination-simple="false"
          pagination-position="bottom"
          default-sort-direction="asc"
          :pagination-rounded="false"
          sort-icon="arrow-up"
          sort-icon-size="is-small"
          @sort="sortClicked"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          @page-change="onPageChanged"
          :page-input="false">
        <b-table-column field="eventId" label="EVENT ID">
          <template v-slot:header="{ column }">
            <table-header :column="column" element-id="223423" header-type="none"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            <b-button type="is-ghost" :disabled="selectedEventId === props.row.eventId"  @click="loadEvent(props.row)">{{ props.row.eventId }}</b-button>
          </template>
        </b-table-column>
        <b-table-column field="date" label="DATE" sortable>
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="date" tooltip="Filter date" element-id="254788453"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            {{ getDate(props.row.date) }}
          </template>
        </b-table-column>
        <b-table-column field="time" label="TIME">
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="time" tooltip="Filter time" element-id="25444"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            {{ getTime(props.row.date) }}
          </template>
        </b-table-column>
        <b-table-column field="origin" label="ORIGIN" sortable>
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="search"
                          element-id="223422"
                          tooltip="Filter Origin"
                          :table-header-data="tableHeaderData"
                          @onSort="onSort"
            ></table-header>
          </template>
          <template v-slot="props">
            {{ props.row.origin ? props.row.origin : '-' }}
          </template>
        </b-table-column>
        <b-table-column field="destination" label="DESTINATION" sortable>
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="search" tooltip="Filter Destination" element-id="4674435"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            {{ props.row.destination ? props.row.destination : '-' }}
          </template>
        </b-table-column>
        <b-table-column field="incidentType" label="INCIDENT TYPE" sortable>
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="search" tooltip="Filter INCIDENT TYPE" element-id="4674434"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            {{ props.row.incidentType }}
          </template>
        </b-table-column>
        <b-table-column field="userType" label="USER TYPE">
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="search" tooltip="Filter user type"
                          element-id="4674438" :table-header-data="tableHeaderData"
                          @onSort="onSort"></table-header>
          </template>
          <template v-slot="props">
            {{ props.row.userType }}
          </template>
        </b-table-column>
      </b-table>
    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {getDate, getRiskRatingClass, getTime} from "@/utils/utils";
import DownloadFile from "@/components/download-file/download-file.vue";
import TableHeader from "@/components/table-header/table-header.vue";

export default {
  name: "single-user-incidents-table",
  components: {DownloadFile, TableHeader},
  props:{
    openNewPage: {
      type: Boolean,
      required: true
    },
    selectedEventId:{
      type:String,
      default: ''
    }
  },
  data(){
    return{
      checkedRows:[],
      currentPage: 1
    }
  },
  mounted() {
    this.currentPage = this.pageNumber
  },
  methods:{
    ...mapActions({
      setSingleUserTableHeaderData: 'safetyModule/setSingleUserTableHeaderData',
      fetchVideoUrls: 'safetyModule/getBulkVideoPresignedUrls',
      setTablePage: 'safetyModule/setTablePage',
    }),
    loadEvent(event) {
      console.log('Event:', event)
      let projectId = this.selectedProject._id
      let dataDeviceId = this.selectedDataDevice.id
      if(event.userType.includes('Undefined') || event.userType == null){
        this.$buefy.toast.open({
          duration: 3000,
          message: 'Road user is Undefined',
          type: 'is-danger'
        })
        return
      }
      if(this.openNewPage){
        const params = {
          eventId: event.eventId,
          projectId: projectId,
          dataDeviceId: dataDeviceId,
          openNewPage: this.openNewPage,
          pageNumber: this.currentPage
        }
        this.$emit('onLoadEvent', params)
      }else{
        const params = {
          eventId: event.eventId,
          projectId: projectId,
          dataDeviceId: dataDeviceId,
          pageNumber: this.currentPage
        }
        this.$router.replace({name: 'event-details', params: params})
      }

    },
    sortClicked(field, order){
      console.log('Sorted: ', field, order)
      let tableHeaderData = this.tableHeaderData
      tableHeaderData.activeSorted = {field: field, order:order}
      this.setSingleUserTableHeaderData(tableHeaderData)
    },
    onSort(tableHeaderData){
      this.setSingleUserTableHeaderData(tableHeaderData)
    },
    getDate(date){
      return getDate(date)
    },
    getTime(date){
      return getTime(date)
    },
    getRiskColor(risk){
      return getRiskRatingClass(risk)
    },
    async onDownloadVideosClicked(){
      this.isLoading = true
      let snippetIds = this.checkedRows.map(row => row.videoBlurredSnippetMetadataId)
      console.log('On download videos clicked, snippet ids:', snippetIds)
      let response = await this.fetchVideoUrls(snippetIds)
      console.log('Fetch response:', response)
      this.isLoading = false

      await this.$refs.downloadVideos.downloadFiles(response, 'videos')
    },
    onPageChanged(pageNum){
      console.log('On page changed', pageNum)
      this.setTablePage(pageNum)
    }
  },
  computed: {
    ...mapState({
      selectedProject: state => state.safetyModule.selectedProject,
      selectedDataDevice: state => state.safetyModule.selectedDataDevice,
      tableHeaderData: state => state.safetyModule.singleUserTableHeaderData,
    }),
    ...mapGetters({
      incidentTableData: 'safetyModule/getSingleUserIncidentTable',
      averageValues: 'safetyModule/getAverageValues',
      getFilteredSites: 'safetyModule/getFilteredSites',
      pageNumber: 'safetyModule/getCurrentTablePage',
    }),
    exportData(){
      return  this.incidentTableData.map(dt=>({
        EVENT_ID: dt.eventId,
        DATE: this.getDate(dt.date),
        TIME: this.getTime(dt.date),
        ORIGIN: dt.origin,
        DESTINATION: dt.destination,
        INCIDENT_TYPE: dt.incidentType,
        USER_TYPE: dt.userType,
      }))
    },
    exportFileName(){
      if(this.selectedDataDevice){
        return `${this.selectedDataDevice.name}.csv`
      }else{
        return 'no_name.csv'
      }
    }
  },
  watch:{
    pageNumber(){
      if(this.pageNumber !== this.currentPage){
        this.currentPage = this.pageNumber
      }
    }
  }
}
</script>

<style scoped>

</style>